import React from 'react';
import { MdLogin, MdLogout } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { StackDivider, VStack } from '@tq/ui-components';
import { UseDisclosureProps } from '@tq/ui-components/dist/hooks';

import { useNavigate } from 'hooks';
import { hasPermissionState, isAdminState } from 'store';
import { MobileMenuDrawerItem } from './MobileMenuDrawerItem';

export const MobileMenuDrawerItems: React.FC<UseDisclosureProps> = ({ onClose }) => {
  const { t } = useTranslation('mobile_menu');
  const isAdmin = useRecoilValue(isAdminState);
  const hasPermission = useRecoilValue(hasPermissionState);
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const { navigateToDashboard, navigateToReports, navigateToManageTeam } = useNavigate();

  return (
    <VStack
      divider={<StackDivider />}
      borderColor={COLOURS.gray[250]}
      spacing={0}
      overflowY='auto'
    >
      {hasPermission && (
        <>
          <MobileMenuDrawerItem
            onClick={() => {
              navigateToDashboard();
              onClose?.();
            }}
            text={t('consultation', 'Consultations')}
          />

          <MobileMenuDrawerItem
            onClick={() => {
              navigateToReports();
              onClose?.();
            }}
            text={t('reports', 'Reports')}
          />
        </>
      )}

      {isAdmin && (
        <MobileMenuDrawerItem
          onClick={() => {
            navigateToManageTeam();
            onClose?.();
          }}
          text={t('manage_team', 'Manage team')}
        />
      )}

      {isAuthenticated ? (
        <MobileMenuDrawerItem
          onClick={async () => {
            await instance.logout({
              postLogoutRedirectUri: '/',
            });
          }}
          rightIcon={<MdLogout aria-label={t('logout_icon', 'Log out icon')} />}
          text={t('logout', 'Log out')}
        />
      ) : (
        <MobileMenuDrawerItem
          onClick={async () => {
            await instance.loginRedirect({
              scopes: [process.env.REACT_APP_B2C_SCOPE || ''],
            });
          }}
          rightIcon={<MdLogin aria-label={t('login_icon', 'Log in icon')} />}
          text={t('login', 'Log in')}
        />
      )}
    </VStack>
  );
};
